<p-panel header="Diagnosis Details" [toggleable]="true" [collapsed]="isPASComplete" toggler="header">
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
  </ng-template>
    @if (diagnosis) {
      <div>
        @for (diagnose of diagnosis; track diagnose) {
          <div class="long-label col-span-12">
            ({{ diagnose.icdOrderType }}) {{ diagnose.icdCode.code }} - 
            {{ diagnose.icdCode.description }}
          </div>
        }
      </div>
    }
</p-panel>
